<label class="p-label" *ngIf="label || info || help">
  <div class="flex flex-column gap-xxs">
    <span class="p-label-text" [ngClass]="{ 'required-asterisk': requiredField }">{{ label | translate }}</span>
    <span class="p-label-info" *ngIf="info">{{ info | translate }}</span>
  </div>
  <vnm-help-tip [help]="help" (tooltipClicked)="tooltipClicked.emit()"></vnm-help-tip>
</label>
<div class="p-control">
  <ng-content #input></ng-content>
</div>
